<template>
  <div>
    <van-popup close-on-popstate v-model="showSelectRelationOrder" position="right"
      :style="{ width: '100%', height: '100%', background: '#eeeeee', transform: 'none', top: 0 }" get-container="body">
      <van-nav-bar @click-left="showSelectRelationOrder = false" @click-right="openDateSelect">
        <template #left>
          <van-icon color="#00C8D2" name="arrow-left" size="20" />
        </template>
        <template #right>
          <van-icon color="#00C8D2" name="calendar-o" size="28" />
        </template>
        <template #title>
          <van-tabs @change="handleRelationTabsChange" type="card" color="#00C8D2" title-active-color="#FFFFFF"
            v-model="relationOrderTypeValue" v-if="tabs.length > 1">
            <van-tab :name="item.type" :title-style="{ width: '100px' }" :title="item.title"
              v-for="(item, index) in tabs" :key="index"></van-tab>
          </van-tabs>
          <span v-else-if="tabs.length == 1 && tabs[0].type == 'pound'">过磅单</span>
          <span v-else-if="tabs.length == 1 && tabs[0].type == 'ncc'">NCC订单</span>
          <span v-else>关联订单</span>
        </template>
      </van-nav-bar>
      <van-search @search="onSearch" @clear="onSearch" @blur="onSearch" v-model="nccQueryParams.keyword"
        placeholder="请搜索关键字" />
      <div v-for="(item, index) in orderSelectData" :key="index" style="position: relative;"
        @click.stop="handleRealationOrderSelect(item)">
        <van-cell style="margin-top: 10px;background-color: #FFFFFF;">
          <template #title>
            <p>
              <span>{{ item.orderType == 'ncc' ? '订单号' : '过磅单' }}：</span>
              <span>{{ item.orderNumber }}</span>
            </p>
            <!-- <p v-if="item.orderType == 'ncc' && item['VFIRSTBILLCODE']">
            <span>订单号：</span>
            <span>{{ item['VFIRSTBILLCODE'] }}</span>
          </p> -->
          </template>
          <template #label>
            <p>供应商名称：{{ item.connection || "--" }}</p>
            <p>{{ item.orderType === 'ncc' ? '物料名称' : '业务线' }}：{{ item.product || "--" }}</p>
            <template v-if="item.orderType == 'ncc'">
              <p>规格：{{ item.MATERIALSPEC || "--" }}</p>
              <p>型号：{{ item.MATERIALTYPE || "--" }}</p>
              <p>品牌：{{ item.VFREE1NAME || "--" }}</p>
              <p>主单位：{{ item.CUNITNAME || "--" }}</p>
              <!-- <p>单据类型：<span style="color: red;">{{ item.INVOICE_TYPE == 1 ? '采购订单' : item.INVOICE_TYPE == 2 ? '销售订单' : '--' }}</span></p> -->
            </template>
            <p>订单日期：{{ item.date || "--" }}</p>
            <template v-if="item.orderType == 'pound'">
              <p>货物名称：{{ item.goods_name || "--" }}</p>
              <p>规格：{{ item.spec || "--" }}</p>
              <p>型号：{{ item.model || "--" }}</p>
              <p>品牌：{{ item.brand || "--" }}</p>
              <p>收货仓库：{{ item.warehouse || "--" }}</p>
              <p>供应商：{{ item.supplier || "--" }}</p>
              <!-- <p>堆垛位置：{{ item.stacking_position || "--" }}</p> -->
              <p>批次：{{ item.batch || "--" }}</p>
              <!-- <p>收货方：{{ item.recipient || "--" }}</p> -->
              <!-- <p>流水号：{{ item.serial_number || "--" }}</p> -->
            </template>
          </template>
        </van-cell>
        <span class="order-select-icon" v-show="!!selectOrder[item.id]">
          <van-icon name="success" size="12" color="#FFFFFF" />
        </span>
      </div>
      <div style="height: 130px;background-color: #f4f5f6;"></div>
      <div class="footer-cont">
        <van-button :disabled="noConfirm" @click="handleConfirmDialog" type="primary" block class="btnStyle1">确
          认</van-button>
      </div>
      <van-calendar ref="calendar" color="#00C8D2" type="range" :default-date="defaultDate"
        v-model="showSelectRelationOrderDate" :min-date="minDate" :max-date="maxDate" @confirm="handelDateConfirm" />
      
    <van-dialog v-model="confirm.visible" show-cancel-button confirmButtonColor="#00C8D2"
      @confirm="handleRealationOrderChange">
      <template #title>
        <div class="confirm-dialog-title">你已选择{{ confirm.data.length }}个订单：</div>
        <div class="confirm-dialog-content">
          <p v-for="(item, index) in confirm.data" :key="index">订单{{ index + 1 }}：{{ item.orderNumber }}</p>
        </div>
      </template>
    </van-dialog>
      </van-popup>
  </div>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';
export default {
  name: 'AppointOrderSelector',
  props: {
    query: {
      type: Object,
      default: () => { }
    },
    selected: {
      type: Object,
      default: () => { }
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      confirm: {
        visible: false,
        data: []
      },
      defaultDate: [],
      relationOrderTypeValue: "",
      showSelectRelationOrder: false,
      showSelectRelationOrderDate: false,
      nccQueryParams: {
        page_size: 100,
        page: 1,
        begin_datetime: "",
        end_datetime: "",
        keyword: ""
      },
      orderSelectData: [],
      count: 0,
      tabs: [],
      minDate: new Date(moment().year() - 5, 0, 1),
      maxDate: new Date(moment().year() + 10, 0, 1),
      selectOrder: {},
      ncc_wl_list: [],
      defaultOptionDate: {
        ncc: {
          begin_datetime: moment().subtract(1, 'years').startOf('day').unix(),
          end_datetime: moment().endOf('day').unix()
        },
        pound: {
          begin_datetime: moment().startOf('day').unix(),
          end_datetime: moment().add(100, 'years').endOf('day').unix(),
        }
      }
    };
  },
  methods: {
    onSearch() {
      if (this.relationOrderTypeValue == "ncc") {
        this.getNccOrder();
      } else {
        this.getPoundOrder();
      }
    },
    // 打开日期选择器
    openDateSelect() {
      this.nccQueryParams.begin_datetime = '';
      this.nccQueryParams.end_datetime = '';
      this.showSelectRelationOrderDate = true;
    },
    // 日期选择器过滤事件
    handelDateConfirm(value) {
      this.nccQueryParams.begin_datetime = moment(value[0]).unix();
      this.nccQueryParams.end_datetime = moment(value[1]).unix();
      if (this.relationOrderTypeValue == "ncc") {
        this.getNccOrder();
      } else {
        this.getPoundOrder();
      }
      this.showSelectRelationOrderDate = false;
    },
    // NCC订单和过磅单Tabs切换事件
    handleRelationTabsChange(name) {
      this.nccQueryParams.keyword = "";
      this.nccQueryParams.begin_datetime = "";
      this.nccQueryParams.end_datetime = "";
      this.$refs.calendar.reset();
      if (name == "ncc") {
        this.nccQueryParams.page = 1;
        this.orderSelectData = [];
        this.$nextTick(() => {
          this.getNccOrder();
        });
      }
      if (name == "pound") {
        this.nccQueryParams.page = 1;
        this.orderSelectData = [];
        this.$nextTick(() => {
          this.getPoundOrder();
        });
      }
      this.selectOrder = {}
    },
    // 弹出关联订单选择
    async open() {
      this.checkOrderTabs()
      this.handleSelectOrderValue()
      this.showSelectRelationOrder = true
    },
    // 处理赋值
    handleSelectOrderValue() {
      let selected = {}
      if (this.$props.selected['ref_order_id']) {
        let ids = this.$props.selected['ref_order_id'].split('/');
        let names = this.$props.selected['ref_order_name'].split('/');
        let type = this.$props.selected['ref_order_type'];
        ids.map((item, index) => {
          selected[item] = {
            id: item,
            orderType: type,
            orderNumber: names[index]
          }
        })
      }
      this.selectOrder = selected;
      this.ncc_wl_list = this.$props.selected['ncc_wl_list'] || [];
    },
    handleConfirmDialog() {
      this.confirm.data = Object.values(this.selectOrder).filter((e) => !!e);
      this.confirm.visible = true;
    },
    // 确认关联订单
    handleRealationOrderChange() {
      let params = {}
      let ids = [];
      let orderType = '';
      let orderNumbers = [];
      this.confirm.data.map((item) => {
        ids.push(item.id);
        orderType = item.orderType;
        orderNumbers.push(item.orderNumber);
      })
      params.id = ids.join('/');
      params.orderType = orderType;
      params.orderNumber = orderNumbers.join('/');
      this.confirm.visible = false;
      const wl_data = this.ncc_wl_list.map((item) => {
        return {
          ...item,
          uuid: Object.values(item).join('-')
        }
      });
      const result_wl_data = params.orderType == 'ncc' ? _.uniqBy(wl_data, 'uuid') : [];
      this.$emit('change', params.id, params.orderType, params.orderNumber, result_wl_data);
      this.showSelectRelationOrder = false;
    },
    // 选择管理订单
    handleRealationOrderSelect(data) {
      if (!this.selectOrder[data.id]) {
        if (!this.multiple) {
          this.$set(this, 'selectOrder', {});
          if (data.orderType == 'ncc') {
            this.$set(this, 'ncc_wl_list', []);
          }
        }
        if (data.orderType == 'ncc') {
          this.ncc_wl_list.push({
            vbillcode: data.VBILLCODE || '',
            matname: data.MATNAME || '',
            matcode: data.MATCODE || ''
          })
        }
        this.$set(this.selectOrder, data.id, data);
      } else {
        this.$set(this.selectOrder, data.id, null);
        if (data.orderType == 'ncc') {
          this.ncc_wl_list = this.ncc_wl_list.filter((e) => e.vbillcode != data.VBILLCODE)
        }
      }

      // if (data.orderType === "ncc") {
      //   if (!this.selectOrder[data.id]) {
      //     if (!this.multiple) {
      //       if (Object.keys(this.selectOrder).length > 0) {
      //         this.$set(this, 'selectOrder', {});
      //         this.$set(this, 'ncc_wl_list', []);
      //       }
      //     }
      //     this.$set(this.selectOrder, data.id, data);
      //     if (data.orderType == 'ncc') {
      //       this.ncc_wl_list.push({
      //         vbillcode: data.VBILLCODE || '',
      //         matname: data.MATNAME || '',
      //         matcode: data.MATCODE || ''
      //       })
      //     }
      //     return
      //   }
      //   this.$set(this.selectOrder, data.id, null);
      //   if (data.orderType == 'ncc') {
      //     this.ncc_wl_list = this.ncc_wl_list.filter((e) => e.vbillcode != data.VBILLCODE)
      //   }
      // } else {
      //   if (!this.selectOrder[data.id]) {
      //     if (!this.multiple) {
      //       if (Object.keys(this.selectOrder).length > 0) {
      //         this.$set(this, 'selectOrder', {});
      //       }
      //     }
      //     this.$set(this.selectOrder, data.id, data);
      //     return
      //   }
      //   this.$set(this.selectOrder, data.id, null);
      // }
    },
    async checkOrderTabs() {
      let params = {}
      let url_1 = '/api/queue/pound/list_ncc';
      let url_2 = '/api/queue/pound/list_pound';
      if (this.query.id) {
        params.booking_id = this.query.id;
        url_1 = '/api/queue/pound/list_ncc_by_booking_id';
        url_2 = '/api/queue/pound/list_pound_by_booking_id';
      }
      let resp_1 = await this.$common.http({
        url: url_1,
        data: {
          ...params,
          page_size: 1,
          page: 1,
          business_id: this.query.business_id
        }
      });
      let resp_2 = await this.$common.http({
        url: url_2,
        data: {
          ...params,
          page_size: 1,
          page: 1,
          sub_com_id: this.query.comId,
          // business_id: this.query.business_id
        }
      });
      let tabs = [];
      if (Number(resp_2.data.data.total) > 0) {
        tabs.push({
          type: 'pound',
          title: '过磅单'
        });
      }
      if (Number(resp_1.data.data.count) > 0) {
        tabs.push({
          type: 'ncc',
          title: 'NCC订单'
        });
      }
      this.tabs = tabs;
      // 即没有过磅单也没有NCC订单
      let no_pound_no_ncc = resp_1.data.data.count == 0 && resp_2.data.data.total == 0;
      // 没有过磅单，但有NCC订单
      let no_pound = resp_1.data.data.count > 0 && resp_2.data.data.total == 0;
      // 没有NCC订单，但有过磅单
      let no_ncc = resp_1.data.data.count == 0 && resp_2.data.data.total > 0;
      // 有NCC订单也有过磅单
      let pound_ncc = resp_1.data.data.count > 0 && resp_2.data.data.total > 0;

      if (no_pound_no_ncc) {
        this.nccQueryParams.keyword = "";
        this.nccQueryParams.page = 1;
        this.orderSelectData = [];
        this.relationOrderTypeValue = "";
        return;
      }

      if (no_ncc) {
        this.nccQueryParams.keyword = "";
        this.nccQueryParams.page = 1;
        this.orderSelectData = [];
        this.relationOrderTypeValue = "pound";
        this.getPoundOrder();
        return;
      }

      if (no_pound) {
        this.nccQueryParams.keyword = "";
        this.nccQueryParams.page = 1;
        this.orderSelectData = [];
        this.relationOrderTypeValue = "ncc";
        this.getNccOrder();
        return;
      }

      if (pound_ncc) {
        this.nccQueryParams.keyword = "";
        this.nccQueryParams.page = 1;
        this.orderSelectData = [];
        if (this.$props.selected['ref_order_type'] && this.$props.selected['ref_order_type'].indexOf('ncc') > -1) {
          this.relationOrderTypeValue = "ncc";
          this.getNccOrder();
          return;
        }
        this.relationOrderTypeValue = "pound";
        this.getPoundOrder();
        return;
      }

    },
    // 获取NCC订单列表
    async getNccOrder() {
      let data = {
        ...this.nccQueryParams,
        business_id: this.query.business_id
      };
      if (!(data.begin_datetime && data.end_datetime)) {
        data = Object.assign(data, this.defaultOptionDate.ncc);
      }
      let url = "/api/queue/pound/list_ncc"
      if (this.query.id) {
        data.booking_id = this.query.id;
        url = "/api/queue/pound/list_ncc_by_booking_id"
      }
      let dataObj = await this.$common.http({ url, data });
      if (dataObj.data.errcode == 0) {
        this.orderSelectData = dataObj.data.data.data.map((item) => {
          return {
            ...item,
            id: item.VBILLCODE + '-' + item.MATCODE,
            orderNumber: item.VBILLCODE + '-' + item.MATCODE,
            order: item.VBDEF11,
            connection: item.SUPPLIERNAME,
            product: item.MATNAME,
            date: item.DBILLDATE,
            orderType: "ncc"
          };
        });
        this.count = dataObj.data.data.count;
      }
    },
    // 获取过磅单列表
    async getPoundOrder() {
      let data = {
        ...this.nccQueryParams,
        // business_id: this.query.business_id
      };
      if (!(data.begin_datetime && data.end_datetime)) {
        data = Object.assign(data, this.defaultOptionDate.pound);
      }
      let url = "/api/queue/pound/list_pound"
      if (this.query.id) {
        data.booking_id = this.query.id;
        url = "/api/queue/pound/list_pound_by_booking_id"
      }
      if (this.query.comId) {
        data.sub_com_id = this.query.comId;
      }
      let dataObj = await this.$common.http({ url, data });
      if (dataObj.data.errcode == 0) {
        this.orderSelectData = dataObj.data.data.data.map((item) => {
          return {
            ...item,
            id: item.id,
            orderNumber: item.pound_number,
            connection: item.unit,
            product: item.business_name,
            date: item.effective_date,
            orderType: "pound",
          };
        });
        this.count = dataObj.data.data.count;
      }
    }
  },
  computed: {
    noConfirm() {
      const data = Object.values(this.selectOrder).filter((e) => !!e);
      return data.length == 0;
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";

.order-select-icon {
  position: absolute;
  top: 0;
  right: 0;
  width: 25px;
  height: 25px;
  background-color: #00C8D2;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0 0 0 8px;
}

.confirm-dialog-title {
  color: #ee0a24;
  text-align: left;
  padding: 0 20px;
  font-size: 18px;
}
.confirm-dialog-content {
  text-align: left;
  padding: 0 20px 0;
  font-size: 16px;
  color: #666666;
  min-height: 40px;
  overflow-y: auto;
  max-height: 360px;
  p {
    margin: 10px 0;
    word-break: break-all;
  }
}
/deep/ .van-cell__label p {
  word-break: break-all;
}
</style>
